module.exports = __webpack_public_path__ + "static/media/house_11.a19b3179.jpg";